import React, { useEffect } from 'react';
import { object, boolean } from 'prop-types';
import { RichText } from '@fiverr-private/cms_ui';

import { useTracker } from '../../../utils/bi';
import HeroMedia from '../../../components/HeroMedia/component/HeroMedia';

import { PAGE_TYPE_CONFIG } from '../../../utils/pageTypesConfig';
import ContentNav from './components/contentNav/ContentNav';
import GeneratedBreadcrumbs from './components/breadcrumbs/Breadcrumbs';
import componentsByType from './componentsByType';

import './index.scss';

const ContentLandingPage = (props) => {
    const {
        context,
        seoMetaTags,
        content,
        headerBanner,
        introduction,
        placeholders = {},
        generateTableOfContent,
        isTableOfContentNumbered,
        pageInfo
    } = props;
    const { pageViewed } = useTracker(context);
    const { slug } = seoMetaTags.fields;
    const pageType = pageInfo.pageType;
    const { breadcrumbs, addSourceToAnchorElements, headerBannerComponent } = PAGE_TYPE_CONFIG[pageType];
    const { generateBreadcrumbs } = breadcrumbs;
    const HeaderBanner = headerBannerComponent || HeroMedia;

    useEffect(() => { pageViewed({ slug, pageInfo }); }, [pageViewed, slug, pageInfo]);

    useEffect(() => {
        if (addSourceToAnchorElements) {
            addSourceToAnchorElements(pageInfo.pathHierarchy);
        }
    }, [addSourceToAnchorElements, pageInfo.pathHierarchy]);

    const h3Headings = content && content.content
        .map((row) => row.tag === 'h3' ? row.content[0].value : undefined)
        .filter((heading) => !!heading);

    return (
        <div className="landing-page content-hub">
            {headerBanner && <HeaderBanner {...headerBanner}/>}
            <div className="max-width-container">
                {generateBreadcrumbs && <GeneratedBreadcrumbs pageType={pageType} pathHierarchy={pageInfo.pathHierarchy} pageUrl={seoMetaTags.fields.pageUrl}/>}
                {introduction && <RichText {...introduction} placeholders={placeholders}/>}
                {generateTableOfContent && <ContentNav headings={h3Headings} isNumbered={isTableOfContentNumbered}/>}
                {content && <RichText {...content}
                    embeddedComponents={componentsByType}
                    headingAnchorToUse={['h3']}
                    placeholders={placeholders}/>}
            </div>
        </div>
    );
};

ContentLandingPage.propTypes = {
    context: object,
    seoMetaTags: object,
    content: object,
    headerBanner: object,
    introduction: object,
    placeholders: object,
    generateTableOfContent: boolean,
    isTableOfContentNumbered: boolean
};

export default ContentLandingPage;
